import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en/translation.json';

/**
 * i18n bootstrap. English ships in-bundle; additional locales can be lazy-loaded
 * later. The host can override the detected language via the init handshake
 * `locale` field (applied by changing i18n.language at runtime).
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en } },
    fallbackLng: 'en',
    supportedLngs: ['en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'navigator', 'htmlTag'],
      caches: [],
    },
  });

export default i18n;
